import React       from 'react';
import { getPage } from '../pages';
import BoxGrid     from './BoxGrid';
import Droppable   from './Droppable';
import { objType } from 'types';


type DndPropsType = {
    size:       number[];
    question:   number;
    pageNum:    number;
    wideScreen: boolean;
    feedBack:   string;
    nextPage:   () => void;
}

const Dnd: React.FC<DndPropsType> = ({ 
    size, 
    wideScreen, 
    pageNum,
    question, 
    feedBack,
    nextPage
}) => {

    const [finalPositions, setFinalPositions] = React.useState([false, false])
    const [droppablePos0, setDroppablePos0]   = React.useState({ x:0, y:0 } as objType)
    const [droppablePos1, setDroppablePos1]   = React.useState({ x:0, y:0 } as objType)
    const [tensVal, setTensVal]               = React.useState(-1)


    React.useEffect(() => {
      if (pageNum === getPage('dragTen2')) {
        setTimeout(() => {
          setTensVal(2)
        },2000)
      }
      if (pageNum === getPage('dragTen3')) {
        setTimeout(() => {
          setTensVal(3)
        },2000)
      }
      if (pageNum === getPage('dragTen4')) {
        setTimeout(() => {
          setTensVal(4)
        },2000)
      }
      if (pageNum === getPage('returnTen4')) {
          setTensVal(3)
      }
    },[pageNum])

    
    return(
        <>
             {
                 wideScreen && 
                 <BoxGrid
                    size          = { size }
                    range         = { 1 }
                    droppablePos0 = { droppablePos0 }
                    droppablePos1 = { droppablePos1 }
                    resetPos      = { (!finalPositions[0] || !finalPositions[1]) }
                    pageNum       = { pageNum }
                    tensVal       = { tensVal }
                    wideScreen
                 />
             }
             {
                 wideScreen && 
                 <Droppable 
                 size              = { size }
                 pageNum           = { pageNum }
                 question          = { question }
                 tensVal           = { tensVal }
                 wideScreen        = { wideScreen }
                 feedBack          = { feedBack }
                 droppablePos0     = { droppablePos0 }
                 droppablePos1     = { droppablePos1 }
                 finalPositions    = { finalPositions }
                 setFinalPositions = { setFinalPositions }
                 setDroppablePos0  = { setDroppablePos0 }
                 setDroppablePos1  = { setDroppablePos1 }
                 nextPage          = { nextPage }
 
              />
             }
             {
                 !wideScreen && 
                 <Droppable 
                 size              = { size }
                 pageNum           = { pageNum }
                 question          = { question }
                 wideScreen        = { wideScreen }
                 feedBack          = { feedBack }
                 tensVal           = { tensVal }
                 droppablePos0     = { droppablePos0 }
                 droppablePos1     = { droppablePos1 }
                 finalPositions    = { finalPositions }
                 setFinalPositions = { setFinalPositions }
                 setDroppablePos0  = { setDroppablePos0 }
                 setDroppablePos1  = { setDroppablePos1 }
                 nextPage          = { nextPage }
 
              />
             }
            
             {
                 !wideScreen && 
                 <BoxGrid
                    size          = { size }
                    range         = { 1 }
                    tensVal       = { tensVal }
                    droppablePos0 = { droppablePos0 }
                    droppablePos1 = { droppablePos1 }
                    pageNum       = { pageNum }
                    resetPos      = { (!finalPositions[0] || !finalPositions[1]) }
                    wideScreen    = { false }
                 />
             }
             <BoxGrid
                size          = { size }
                range         = { 6 }
                tensVal       = { tensVal }
                droppablePos0 = { droppablePos0 }
                droppablePos1 = { droppablePos1 }
                resetPos      = { (!finalPositions[0] || !finalPositions[1]) }
                pageNum       = { pageNum }
                wideScreen    = { wideScreen }
             />
        </>
    )
}

  export default Dnd

  
